import React, { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from '../../utils/letters'

/** Mismo límite que backend (carrusel del home). */
const CAROUSEL_MAX_ITEMS = 5;
const RESOURCE_NOT_FOUND_FALLBACK = `${process.env.PUBLIC_URL}/img/404_not_found.png`;

const IMG_LOCAL_FALLBACK = [
    { img_url: "img/carousel/mujer.webp", tittle: "Explora los cursos", subtittle: "Organización", activo: true, url_dest: "/cursos" },
];
const credencialesDB = [
    { id: 1, src: "/img/credentials/certhia.webp", alt: "Certificación certhia" },
    { id: 2, src: "/img/credentials/sence.webp", alt: "Certificación Sence" },
];

const Carousel = ({ carouselData, isLoading }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleImageError = (event) => {
        const target = event.currentTarget;
        if (!target) {
            return;
        }

        // Evita loop infinito si también falla el fallback.
        if (target.src?.includes('/img/404_not_found.png')) {
            target.onerror = null;
            return;
        }

        target.onerror = null;
        target.src = RESOURCE_NOT_FOUND_FALLBACK;
    };

    // Datos de BDD acotados a 5; si no hay, placeholders locales
    const listaFinal = useMemo(() => {
        if (carouselData && carouselData.length > 0) {
            return carouselData.slice(0, CAROUSEL_MAX_ITEMS);
        }
        return IMG_LOCAL_FALLBACK;
    }, [carouselData]);

    useEffect(() => {
        if (listaFinal.length > 0) {
            const interval = setInterval(() => {
                setActiveIndex((prev) => (prev + 1) % listaFinal.length);
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [listaFinal.length]);

    useEffect(() => {
        setActiveIndex((prev) => (listaFinal.length ? prev % listaFinal.length : 0));
    }, [listaFinal.length]);

    if (isLoading) {
        return (
            <div className="loader-container-carousel">
                <div className="loader-content">
                    <p className="txt-loading">Cargando imágenes...</p>
                </div>
            </div>
        );
    }

    let credencialesSeguras = [...credencialesDB];
    if (credencialesSeguras.length > 0) {
        while (credencialesSeguras.length < 12) {
            credencialesSeguras = [...credencialesSeguras, ...credencialesDB];
        }
    }

    return (
        <>
            <section className="img-carousel">
                {listaFinal.map((img, index) => (
                    <div
                        key={img.id || index}
                        className={`carousel-item ${index === activeIndex ? 'active' : ''}`}
                    >
                        {/* FIX: Leemos los campos exactos que manda Django ('titulo', 'subtitulo', 'imagen_url') pero mantenemos soporte para 'imgLocal' */}
                        <img
                            src={img.imagen_url || img.img_url}
                            alt={img.titulo || img.tittle}
                            onError={handleImageError}
                        />
                        <div className="hero-overlay">
                            <div className='inf-carousel'>
                                <span className='txt_one'>{capitalizeFirstLetter(img.titulo || img.tittle)}</span>
                                <div className="inf-carousel-btns">
                                    <Link to={img.url_destino || img.url_dest} className="txt-button"><span><span className="text-hide-mobile">Ver </span>más</span></Link>
                                    <span className="txt_two">{capitalizeFirstLetter(img.subtitulo || img.subtittle)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                <div className="carousel-dots">
                    {listaFinal.map((_, index) => (
                        <span
                            key={index}
                            className={`dot ${index === activeIndex ? 'active' : ''}`}
                            onClick={() => setActiveIndex(index)}
                        ></span>
                    ))}
                </div>


            </section>

            <div className="banner-credentials">
                <div className="credentials-track">
                    {/* Lista Original */}
                    <div className="credentials-list">
                        {credencialesSeguras.map((credencial, index) => (
                            <img 
                                key={`orig-${credencial.id}-${index}`} 
                                src={credencial.src} 
                                alt={credencial.alt} 
                                className="credencial-img" 
                            />
                        ))}
                    </div>
                    
                    {/* Lista Clonada */}
                    <div className="credentials-list" aria-hidden="true">
                        {credencialesSeguras.map((credencial, index) => (
                            <img 
                                key={`clone-${credencial.id}-${index}`} 
                                src={credencial.src} 
                                alt={credencial.alt} 
                                className="credencial-img" 
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Carousel;